<template>
  <div><a href="https://www.imatrix.co.jp" target="_blank" rel="noopener noreferrer">© 2021 imatrix corp.</a></div>
</template>
